up.compiler('.pdf-preparation', (element) => {
  window.status = 'pdf-prepared';
});
